var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-col", { attrs: { cols: "6" } }, [
    _c(
      "div",
      { staticClass: "d-flex my-1" },
      [
        _c(
          "b-button",
          {
            staticClass: "d-flex",
            attrs: { variant: "outline-primary" },
            on: {
              click: function ($event) {
                return _vm.changeActiveFilter()
              },
            },
          },
          [
            _c("div", { staticClass: "text-nowrap" }, [
              _vm._v(
                _vm._s(
                  _vm.chosenFilters.length > 0
                    ? _vm.chosenFilters.length + " " + _vm.filtersChosenText
                    : _vm.title
                )
              ),
            ]),
            _c("b-icon", {
              staticClass: "ml-1",
              attrs: { scale: "0.5", icon: "caret-down-fill", variant: "dark" },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }